// @flow

import React from 'react';
import classNames from 'classnames';
import type { Node as ReactNode } from 'react';

type OptionGroupProps = {
  key?: string,
  optionIndex: number,
  children?: any,
  className?: string,
  label?: ReactNode,
  option: Object,
  isSelected: boolean,
  isDisabled: boolean,
  onSelect: Function,
};

const OptionGroup = (props: OptionGroupProps) => {
  const onClickCategory = (event, value, label) => {
    if (!props.isDisabled) {
      props.onSelect(
        {
          label: label,
          value: value,
          category: true,
        },
        event
      );
    }
  };

  const { option, isSelected, isDisabled } = props;
  const className = classNames(props.className, option.className);
  const groupClassNames = classNames('Select-option-group-label', {
    'is-selected': isSelected,
    'is-disabled': isDisabled,
  });

  // if (option.disabled) {
  //   return <div className={className}>{props.children}</div>;
  // }

  return (
    <div className={className} style={option.style} title={option.title}>
      <div
        className={groupClassNames}
        onClick={(event) => onClickCategory(event, option.value, option.label)}
      >
        {props.label}
      </div>
      {props.children}
    </div>
  );
};

export default OptionGroup;
